// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Momv","buttons":"RemoveExpirationActionButtons_buttons__2mLra"};